import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout';

const ReadmeChat = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Obter o hash da URL (sem o #)
        const hash = location.hash.substring(1);
        
        if (!hash) {
          setNotFound(true);
          setLoading(false);
          return;
        }
        
        // Aqui você pode implementar a lógica para buscar o conteúdo específico
        // com base no hash, seja de um arquivo estático ou de uma API
        
        // Simulação - encontrar o conteúdo baseado no hash
        // Em uma implementação real, você buscaria de uma API ou arquivo
        const knowledgeBaseData = [
          {
            id: 23,
            title: 'Reorganização do Menu Lateral e Sub-menus',
            content: `
              <h2>Reorganização do Menu Lateral e Sub-menus</h2>
              
              <h3>Descrição</h3>
              <p>Reorganização do menu lateral com sub-menus para Configurações do Sistema e adição de links separados para Base de Conhecimento e Dashboard de Conhecimento.</p>
              
              <h3>Problema</h3>
              <p>O menu lateral não possuía organização de links relacionados em sub-menus, o que dificultava a navegação e acesso rápido às funcionalidades do sistema. Os links para itens de administração e configuração estavam espalhados em diferentes lugares da interface.</p>
              
              <h3>Solução</h3>
              <p>Implementamos as seguintes melhorias na navegação:</p>
              <ol>
                <li>Criação de um dropdown para "Configurações do Sistema" que agrupa os seguintes sub-links:
                  <ul>
                    <li>Configurações Gerais</li>
                    <li>Configuração de Email</li>
                    <li>Dashboard do Sequelize</li>
                    <li>Logs de Erros</li>
                  </ul>
                </li>
                <li>Adição de ícones apropriados e links separados para Base de Conhecimento e Dashboard de Conhecimento</li>
                <li>Remoção do menu de administração duplicado no topo da página</li>
                <li>Remoção do link de Configurações de Email do dropdown do perfil de usuário</li>
              </ol>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Menu dropdown de Configurações do Sistema
&lt;li className={\`nav-item dropdown \${
  isActive('/system-settings') || 
  isActive('/admin/email-config') || 
  isActive('/admin/sequelize') || 
  isActive('/admin/error-logs') ? 'active' : ''
}\`}&gt;
  &lt;a 
    href="#" 
    className="nav-link dropdown-toggle" 
    onClick={handleDropdownToggle}
    aria-expanded="false"
  &gt;
    &lt;span className="nav-link-icon d-md-none d-lg-inline-block"&gt;
      &lt;svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"&gt;
        &lt;path stroke="none" d="M0 0h24v24H0z" fill="none" /&gt;
        &lt;path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" /&gt;
        &lt;circle cx="12" cy="12" r="3" /&gt;
      &lt;/svg&gt;
    &lt;/span&gt;
    &lt;span className="nav-link-title"&gt;Configurações do Sistema&lt;/span&gt;
  &lt;/a&gt;
  &lt;div className="dropdown-menu"&gt;
    &lt;Link to="/system-settings" className="dropdown-item"&gt;
      Configurações Gerais
    &lt;/Link&gt;
    &lt;Link to="/admin/email-config" className="dropdown-item"&gt;
      Configuração de Email
    &lt;/Link&gt;
    &lt;Link to="/admin/sequelize" className="dropdown-item"&gt;
      Dashboard do Sequelize
    &lt;/Link&gt;
    &lt;Link to="/admin/error-logs" className="dropdown-item"&gt;
      Logs de Erros
    &lt;/Link&gt;
  &lt;/div&gt;
&lt;/li&gt;
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Estas melhorias na navegação proporcionam:</p>
              <ul>
                <li>Maior organização e agrupamento lógico de funcionalidades relacionadas</li>
                <li>Navegação mais intuitiva e eficiente</li>
                <li>Redução da poluição visual com a remoção de menus duplicados</li>
                <li>Acesso mais rápido às funcionalidades de administração e configuração</li>
              </ul>
              
              <h3>Comentários do Desenvolvedor</h3>
              <p>Esta reorganização do menu lateral foi implementada a pedido do administrador para melhorar a navegabilidade do sistema. O uso de sub-menus permite agrupar funcionalidades relacionadas, facilitando o acesso e reduzindo a poluição visual da interface.</p>
            `,
            readmeLink: '#23032025---reorganização-do-menu-lateral-e-sub-menus'
          },
          {
            id: 22,
            title: 'Atualização da Marca e Reorganização do Menu',
            content: `
              <h2>Atualização da Marca e Reorganização do Menu</h2>
              
              <h3>Descrição</h3>
              <p>Substituição do nome "trabler" para "Simullact.io", reorganização do menu e adição de link para Configurações do Sistema.</p>
              
              <h3>Problema</h3>
              <p>A interface usava um nome genérico "trabler" e havia inconsistências nas fontes. Faltava também um acesso direto às Configurações do Sistema no menu principal.</p>
              
              <h3>Solução</h3>
              <p>Realizamos as seguintes melhorias na interface:</p>
              <ol>
                <li>Substituição do nome "trabler" pelo nome da plataforma "Simullact.io" em todos os locais relevantes</li>
                <li>Padronização das fontes em todo o menu para garantir consistência visual</li>
                <li>Reorganização dos itens do menu para melhor navegabilidade</li>
                <li>Adição de um link direto para "Configurações do Sistema" no menu principal</li>
                <li>Atualização do rodapé com a nova marca</li>
              </ol>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Substituição do logo por texto estilizado
&lt;h1 className="navbar-brand navbar-brand-autodark"&gt;
  &lt;Link to="/"&gt;
    &lt;span className="navbar-brand-image" style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#fff' }}&gt;Simullact.io&lt;/span&gt;
  &lt;/Link&gt;
&lt;/h1&gt;

// Adição do link para Configurações do Sistema
&lt;li className={\`nav-item \${isActive('/system-settings') ? 'active' : ''}\`}&gt;
  &lt;Link to="/system-settings" className="nav-link"&gt;
    &lt;span className="nav-link-icon d-md-none d-lg-inline-block"&gt;
      &lt;svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"&gt;
        &lt;path stroke="none" d="M0 0h24v24H0z" fill="none" /&gt;
        &lt;path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" /&gt;
        &lt;circle cx="12" cy="12" r="3" /&gt;
      &lt;/svg&gt;
    &lt;/span&gt;
    &lt;span className="nav-link-title"&gt;Configurações do Sistema&lt;/span&gt;
  &lt;/Link&gt;
&lt;/li&gt;

// Atualização do rodapé
&lt;li className="list-inline-item"&gt;
  Copyright © {new Date().getFullYear()} Simullact.io - Plataforma de Investimentos
&lt;/li&gt;
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Estas melhorias na interface proporcionam:</p>
              <ul>
                <li>Fortalecimento da identidade da marca com o nome "Simullact.io"</li>
                <li>Melhor experiência do usuário com uma navegação mais intuitiva</li>
                <li>Acesso mais rápido às configurações do sistema</li>
                <li>Visual mais consistente e profissional em toda a aplicação</li>
              </ul>
              
              <h3>Comentários do Desenvolvedor</h3>
              <p>Esta melhoria foi implementada a pedido do usuário para substituir o nome genérico "trabler" por "Simullact.io", reorganizar o menu e garantir consistência nas fontes. O acesso direto às Configurações do Sistema foi adicionado para facilitar a navegação.</p>
            `,
            readmeLink: '#22032025---atualização-da-marca-e-reorganização-do-menu'
          },
          {
            id: 21,
            title: 'Melhorias Futuras para o Sistema de Documentação',
            content: `
              <h2>Melhorias Futuras para o Sistema de Documentação</h2>
              
              <h3>Descrição</h3>
              <p>Propostas de melhorias e expansões futuras para o sistema de documentação detalhada, incluindo recursos adicionais, 
              integrações e aprimoramentos de usabilidade.</p>
              
              <h3>Problema</h3>
              <p>O sistema atual de documentação, embora funcional, pode ser expandido com recursos adicionais para melhorar a 
              colaboração, usabilidade e integração com outras ferramentas de desenvolvimento. Precisamos planejar as 
              próximas etapas de evolução da plataforma de documentação.</p>
              
              <h3>Solução</h3>
              <p>Implementar gradualmente as melhorias propostas, priorizando aquelas que trarão maior benefício imediato
              para a equipe de desenvolvimento e usuários do sistema. Abaixo estão listadas as principais áreas de melhoria:</p>
              
              <h4>1. Sistema de Comentários Real</h4>
              <ul>
                <li>Implementar API de comentários no backend para persistir comentários dos usuários</li>
                <li>Adicionar funcionalidade de respostas em comentários (threads)</li>
                <li>Implementar notificações quando alguém comenta em uma documentação que você criou</li>
              </ul>
              
              <h4>2. Sistema de Versionamento</h4>
              <ul>
                <li>Adicionar controle de versões para cada documentação</li>
                <li>Permitir visualizar o histórico de alterações</li>
                <li>Implementar comparação entre versões (diff)</li>
              </ul>
              
              <h4>3. Editor WYSIWYG para Documentação</h4>
              <ul>
                <li>Implementar um editor rico para criar e editar documentação</li>
                <li>Suporte para formatação, listas, tabelas</li>
                <li>Upload de imagens e screenshots para ilustrar problemas/soluções</li>
              </ul>
              
              <h4>4. Integração com Ferramentas de Desenvolvimento</h4>
              <ul>
                <li>Vincular documentação a commits específicos no GitHub</li>
                <li>Integrar com sistema de tickets/issues</li>
                <li>Adicionar links para pull requests relacionados</li>
              </ul>
              
              <h4>5. Recursos de Colaboração</h4>
              <ul>
                <li>Sistema de revisão por pares (peer review)</li>
                <li>Marcação de co-autores</li>
                <li>Atribuição de revisores para documentação</li>
              </ul>
              
              <h4>6. Melhorias na Busca e Filtragem</h4>
              <ul>
                <li>Implementar busca full-text</li>
                <li>Filtros avançados (por data, autor, tags múltiplas)</li>
                <li>Recomendação de documentação relacionada</li>
              </ul>
              
              <h4>7. Estatísticas e Métricas</h4>
              <ul>
                <li>Acompanhamento de visualizações</li>
                <li>Estatísticas de utilidade (avaliações dos usuários)</li>
                <li>Gráficos de contribuição por equipe/desenvolvedor</li>
              </ul>
              
              <h4>8. Exportação e Compartilhamento</h4>
              <ul>
                <li>Exportar documentação para PDF</li>
                <li>Gerar links compartilháveis com permissões</li>
                <li>Envio por email diretamente da interface</li>
              </ul>
              
              <h4>9. Enriquecimento Visual</h4>
              <ul>
                <li>Suporte para diagramas interativos</li>
                <li>Gráficos e visualizações de dados</li>
                <li>Incorporação de vídeos demonstrativos</li>
              </ul>
              
              <h4>10. Inteligência Artificial</h4>
              <ul>
                <li>Sugestões automáticas de tags</li>
                <li>Resumo automático de documentações longas</li>
                <li>Geração de tópicos relacionados</li>
              </ul>
              
              <h3>Exemplo de Implementação</h3>
              <p>Abaixo está um exemplo básico da implementação do sistema de comentários:</p>
              
              <pre>
// Model para comentários
const CommentSchema = new mongoose.Schema({
  documentationId: { type: Number, required: true },
  authorId: { type: Number, required: true },
  content: { type: String, required: true },
  parentId: { type: Number, default: null }, // Para respostas em threads
  createdAt: { type: Date, default: Date.now },
  updatedAt: { type: Date, default: Date.now }
});

// API para buscar comentários
router.get('/api/documentation/:id/comments', authenticate, async (req, res) => {
  try {
    const { id } = req.params;
    const comments = await Comment.find({ documentationId: id })
                                .sort({ createdAt: -1 })
                                .populate('authorId', 'name role avatar');
    res.json(comments);
  } catch (error) {
    res.status(500).json({ message: 'Erro ao buscar comentários' });
  }
});

// Componente React para exibir comentários
const CommentSection = ({ documentationId }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  
  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await axiosInstance.get(\`/api/documentation/\${documentationId}/comments\`);
        setComments(response.data);
      } catch (error) {
        console.error('Erro ao buscar comentários:', error);
      }
    };
    
    fetchComments();
  }, [documentationId]);
  
  const handleAddComment = async () => {
    try {
      const response = await axiosInstance.post(\`/api/documentation/\${documentationId}/comments\`, {
        content: newComment
      });
      
      setComments([response.data, ...comments]);
      setNewComment('');
    } catch (error) {
      console.error('Erro ao adicionar comentário:', error);
    }
  };
  
  return (
    &lt;div className="comments-section"&gt;
      &lt;h3&gt;Comentários&lt;/h3&gt;
      
      {/* Formulário para novo comentário */}
      &lt;div className="new-comment"&gt;
        &lt;textarea 
          value={newComment}
          onChange={(e) => setNewComment(e.target.value)}
          placeholder="Adicione um comentário..."
        /&gt;
        &lt;button onClick={handleAddComment}&gt;Enviar&lt;/button&gt;
      &lt;/div&gt;
      
      {/* Lista de comentários */}
      {comments.map(comment => (
        &lt;div key={comment._id} className="comment"&gt;
          &lt;div className="comment-header"&gt;
            &lt;span className="author"&gt;{comment.authorId.name}&lt;/span&gt;
            &lt;span className="date"&gt;{new Date(comment.createdAt).toLocaleString()}&lt;/span&gt;
          &lt;/div&gt;
          &lt;div className="comment-content"&gt;{comment.content}&lt;/div&gt;
        &lt;/div&gt;
      ))}
    &lt;/div&gt;
  );
};
              </pre>
              
              <h3>Processo de Priorização</h3>
              <p>Para decidir quais melhorias implementar primeiro, sugerimos seguir um processo de priorização baseado em:</p>
              <ol>
                <li>Valor imediato para os usuários da plataforma</li>
                <li>Facilidade de implementação</li>
                <li>Dependências técnicas</li>
                <li>Feedback da equipe de desenvolvimento</li>
              </ol>
              
              <p>As melhorias podem ser gradualmente implementadas em sprints, começando pelas mais importantes,
              como o sistema de comentários real e o editor WYSIWYG, que trarão benefícios imediatos para a
              colaboração e qualidade da documentação.</p>
              
              <h3>Conclusão</h3>
              <p>Estas melhorias transformarão nossa base de conhecimento em uma plataforma completa de gestão
              do conhecimento, facilitando a documentação de problemas, soluções e melhorias do sistema.
              A implementação gradual permitirá avaliar o impacto de cada recurso e ajustar o roadmap conforme
              necessário.</p>
            `
          },
          {
            id: 18,
            title: 'Implementação do Sistema de Abas e Quadro Kanban no Painel de Conhecimento',
            content: `
              <h2>Implementação do Sistema de Abas e Quadro Kanban no Painel de Conhecimento</h2>
              
              <h3>Descrição</h3>
              <p>Adição de um sistema de abas no Painel de Conhecimento para alternar entre a visualização da base de conhecimento 
              e uma nova visualização Kanban para gerenciamento de projetos.</p>
              
              <h3>Problema</h3>
              <p>O Painel de Conhecimento exibia apenas as entradas da base de conhecimento, sem oferecer recursos para 
              gestão visual de projetos e tarefas. Além disso, durante a implementação, ocorreu o erro "Module not found: 
              Error: Can't resolve '../components/KanbanBoard' in '/app/src/pages'" porque o componente KanbanBoard 
              necessário não existia no projeto.</p>
              
              <h3>Solução</h3>
              <p>A solução foi implementada em duas etapas principais:</p>
              <ol>
                <li>Atualização do componente KnowledgeDashboard.js para incluir um sistema de abas usando estados React e renderização condicional.</li>
                <li>Criação do componente KanbanBoard.js para visualização e gerenciamento de tarefas em formato Kanban.</li>
              </ol>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Importar o componente KanbanBoard
import KanbanBoard from '../components/KanbanBoard';

// Adicionar estado para controlar a aba ativa
const [activeTab, setActiveTab] = useState('knowledge');

// Adicionar sistema de navegação em abas
&lt;div className="d-flex mb-3"&gt;
  &lt;button 
    className={\`btn \${activeTab === 'knowledge' ? 'btn-primary' : 'btn-outline-primary'}\`} 
    onClick={() => setActiveTab('knowledge')}
  &gt;
    Base de Conhecimento
  &lt;/button&gt;
  &lt;button 
    className={\`btn ms-2 \${activeTab === 'projects' ? 'btn-primary' : 'btn-outline-primary'}\`} 
    onClick={() => setActiveTab('projects')}
  &gt;
    Gestão de Projetos
  &lt;/button&gt;
&lt;/div&gt;

// Renderização condicional baseada na aba ativa
{activeTab === 'knowledge' ? (
  &lt;div&gt;
    // Conteúdo original da base de conhecimento
  &lt;/div&gt;
) : (
  &lt;KanbanBoard /&gt;
)}
              </pre>
              
              <p><strong>2. Criação do componente KanbanBoard.js:</strong></p>
              <pre>
// Componente para visualização Kanban
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const KanbanBoard = () => {
  // Estados para gerenciar tarefas, projetos, etc.
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState('all');
  
  // Carregar dados (simulado com setTimeout)
  useEffect(() => {
    // Código para carregar projetos e tarefas
  }, []);
  
  // Agrupar tarefas por status
  const backlogTasks = filteredTasks.filter(task => task.status === 'backlog');
  const inProgressTasks = filteredTasks.filter(task => task.status === 'in-progress');
  // ...outros grupos de tarefas
  
  return (
    &lt;div&gt;
      {/* Seletor de projetos e botão para adicionar tarefas */}
      
      {/* Visualização em colunas do quadro Kanban */}
      &lt;div className="row g-3"&gt;
        {/* Colunas para diferentes status: Backlog, Em Andamento, etc. */}
      &lt;/div&gt;
      
      {/* Modal para adicionar novas tarefas */}
    &lt;/div&gt;
  );
};

export default KanbanBoard;
              </pre>
              
              <h3>Processo de Implementação e Resolução de Erros</h3>
              <p>Para resolver o erro "Module not found", foi necessário:</p>
              <ol>
                <li>Criar o arquivo <code>frontend/src/components/KanbanBoard.js</code> com a implementação completa do quadro Kanban.</li>
                <li>Reconstruir o container Docker do frontend com <code>docker-compose build frontend</code>.</li>
                <li>Reiniciar o container com <code>docker-compose restart frontend</code>.</li>
              </ol>
              
              <h3>Funcionalidades Implementadas no Quadro Kanban</h3>
              <ul>
                <li>Visualização em quatro colunas: Backlog, Em Andamento, Em Revisão e Concluído.</li>
                <li>Filtro por projeto para exibir apenas tarefas específicas.</li>
                <li>Modal para adicionar novas tarefas com campos para título, descrição, projeto, prioridade, etc.</li>
                <li>Funcionalidade para mover tarefas entre as colunas através de menu dropdown.</li>
                <li>Cartões de tarefas com informações detalhadas, incluindo prioridade, responsável e data de vencimento.</li>
              </ul>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta implementação aprimora significativamente o Painel de Conhecimento, transformando-o em uma ferramenta 
              mais completa que não apenas documenta melhorias e correções, mas também permite o gerenciamento visual 
              de projetos e tarefas relacionados às implementações do sistema.</p>
            `,
            readmeLink: '#18032025---implementação-do-sistema-de-abas-e-quadro-kanban-no-painel-de-conhecimento'
          },
          {
            id: 17,
            title: 'Correção do Erro 401 ao Carregar Cenários Salvos',
            content: `
              <h2>Correção do Erro 401 ao Carregar Cenários Salvos</h2>
              
              <h3>Descrição</h3>
              <p>Solução para o erro "Request failed with status code 401" que ocorre ao tentar carregar cenários salvos na página de Configurações.</p>
              
              <h3>Problema</h3>
              <p>Quando o token de autenticação expira, a página de cenários exibe o erro "Houve um problema ao carregar as configurações: 
              Request failed with status code 401. Os valores padrão estão sendo exibidos." A aplicação não estava tratando corretamente 
              esse caso de erro, deixando o usuário sem saber o que fazer.</p>
              
              <h3>Solução</h3>
              <p>Implementamos um tratamento específico para o erro 401 (Unauthorized) que:</p>
              <ol>
                <li>Identifica quando o erro é devido a problemas de autenticação</li>
                <li>Notifica o usuário que sua sessão expirou</li>
                <li>Limpa os dados da sessão (token e informações do usuário)</li>
                <li>Redireciona automaticamente para a página de login após um breve intervalo</li>
              </ol>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Tratamento específico para erro 401 (Unauthorized)
if (error.response && error.response.status === 401) {
  console.error('Erro de autenticação: token expirado ou inválido');
  toast.error('Sua sessão expirou. Por favor, faça login novamente.');
  
  // Limpar dados da sessão
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  // Redirecionar para login após pequeno delay
  setTimeout(() => {
    window.location.href = '/login';
  }, 2000);
} else {
  console.error('Detalhes do erro:', error.response ? error.response.data : 'Sem detalhes');
  toast.error('Erro ao carregar cenários salvos. Por favor, tente novamente.');
}
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Essa correção melhora significativamente a experiência do usuário ao lidar com tokens expirados, eliminando
              a confusão causada pelo erro 401 e guiando o usuário para a ação correta (fazer login novamente).</p>
            `,
            readmeLink: '#17032025---correção-do-erro-401-ao-carregar-cenários-salvos'
          },
          {
            id: 16,
            title: 'Melhorias no Modal de Detalhes do Período na Página de Relatórios',
            content: `
              <h2>Melhorias no Modal de Detalhes do Período na Página de Relatórios</h2>
              
              <h3>Descrição</h3>
              <p>Aprimoramento do modal de detalhes do período para exibir informações de forma mais clara e completa.</p>
              
              <h3>Problema</h3>
              <p>O modal de detalhes do período na página de relatórios apresentava limitações na exibição de informações, 
              com valores repetidos, espaçamento inadequado e botões pouco intuitivos.</p>
              
              <h3>Solução</h3>
              <p>Implementamos diversas melhorias: aumentamos o tamanho do modal, adicionamos um card para somatória 
              de remunerações, corrigimos o cálculo do Total Alavancado, melhoramos a visualização das colunas na 
              tabela e substituímos o botão "+" por um ícone mais intuitivo.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// 1. Aumento do tamanho do modal
&lt;div className="modal-dialog modal-dialog-centered modal-xl" role="document"&gt;

// 2. Adição de card de remuneração total
&lt;div className="col-md-3"&gt;
  &lt;div className="card"&gt;
    &lt;div className="card-body p-3 text-center"&gt;
      &lt;div className="subheader fw-bold"&gt;Remuneração&lt;/div&gt;
      &lt;div className="h3 text-primary"&gt;{formatCurrencyValue(convertCurrency(periodDailyOperations.reduce((sum, op) =&gt; sum + (parseFloat(op.daily_withdrawal) || 0), 0)))}&lt;/div&gt;
    &lt;/div&gt;
  &lt;/div&gt;
&lt;/div&gt;

// 3. Correção do cálculo do Total Alavancado
&lt;div className="h3 text-azure"&gt;{formatCurrencyValue(convertCurrency(periodDailyOperations.reduce((sum, op) =&gt; sum + (parseFloat(op.total_profit) || 0), 0)))}&lt;/div&gt;
              </pre>
            `,
            readmeLink: '#16032025---melhorias-no-modal-de-detalhes-do-período-na-página-de-relatórios'
          },
          {
            id: 15,
            title: 'Sistema de Monitoramento de Logs',
            content: `
              <h2>Sistema de Monitoramento de Logs</h2>
              
              <h3>Descrição</h3>
              <p>Implementação de um sistema completo para visualização e análise de logs de erros e logs do Docker.</p>
              
              <h3>Problema</h3>
              <p>Não havia uma forma centralizada de visualizar e analisar logs de erros do sistema e logs do Docker, 
              dificultando o diagnóstico e resolução de problemas como erros de envio de email.</p>
              
              <h3>Solução</h3>
              <p>Criamos duas páginas dedicadas: uma para logs de erros do sistema e outra para logs do Docker, 
              com funcionalidades de filtragem, exportação e visualização detalhada.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Função para visualizar logs do Docker
const viewDockerLogs = (containerName, timestamp) => {
  window.open('/admin/docker-logs?container=' + containerName + '&timestamp=' + timestamp, '_blank');
};

// ... restante do código ...
              </pre>
              
              <h3>Funcionalidades Implementadas</h3>
              <ul>
                <li>Visualização de logs de erro do sistema com filtragem por tipo e data</li>
                <li>Visualização detalhada de cada erro com stack trace completo</li>
                <li>Acesso direto aos logs do Docker para cada container</li>
                <li>Filtragem de logs do Docker por intervalo de tempo e nível de log</li>
                <li>Exportação de logs para análise posterior</li>
              </ul>
              
              <h3>Impacto no Sistema</h3>
              <p>Este sistema de monitoramento facilita significativamente o diagnóstico e resolução de problemas, 
              permitindo que administradores identifiquem rapidamente a causa raiz de erros e anomalias no funcionamento 
              da aplicação.</p>
            `,
            readmeLink: '#16032025---implementação-do-sistema-de-monitoramento-de-logs'
          },
          {
            id: 14,
            title: 'Redefinição de Senha do Administrador',
            content: `
              <h2>Redefinição de Senha do Administrador</h2>
              
              <h3>Descrição</h3>
              <p>Implementação de sistema para redefinir a senha do administrador quando necessário.</p>
              
              <h3>Problema</h3>
              <p>O administrador esqueceu a senha e não conseguia acessar o sistema, sem haver uma forma fácil de redefinir a senha.</p>
              
              <h3>Solução</h3>
              <p>Criamos um script para atualizar a senha do administrador diretamente no banco de dados e instruções para executá-lo no container Docker.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Script para atualizar a senha do administrador
const bcrypt = require('bcryptjs');
const { User } = require('./backend/models');

async function updateAdminPassword() {
  try {
    const adminUser = await User.findOne({ where: { email: 'admin@example.com' } });
    
    if (!adminUser) {
      console.error('Usuário administrador não encontrado!');
      return;
    }
    
    const salt = await bcrypt.genSalt(10);
    const hashedPassword = await bcrypt.hash('novasenha123', salt);
    
    await adminUser.update({ password: hashedPassword });
    console.log('Senha do administrador atualizada com sucesso!');
  } catch (error) {
    console.error('Erro ao atualizar senha do administrador:', error);
  }
}

updateAdminPassword();
              </pre>
              
              <h3>Instruções de Uso</h3>
              <ol>
                <li>Crie um arquivo <code>reset-admin-password.js</code> com o código acima</li>
                <li>Acesse o container do backend: <code>docker exec -it investment-backend bash</code></li>
                <li>Execute o script: <code>node reset-admin-password.js</code></li>
                <li>Verifique a mensagem de confirmação "Senha do administrador atualizada com sucesso!"</li>
                <li>Faça login com a nova senha: <code>novasenha123</code></li>
                <li>Altere a senha para uma de sua preferência após o primeiro login</li>
              </ol>
              
              <h3>Impacto no Sistema</h3>
              <p>Este procedimento permite recuperar o acesso administrativo ao sistema quando a senha é esquecida, 
              sem necessidade de reinstalação ou perda de dados.</p>
            `,
            readmeLink: '#15032025---redefinição-de-senha-do-administrador'
          },
          {
            id: 13,
            title: 'Problema de Perda de Histórico de Simulações',
            content: `
              <h2>Problema de Perda de Histórico de Simulações</h2>
              
              <h3>Descrição</h3>
              <p>Correção do problema onde o histórico de simulações era perdido após determinadas ações.</p>
              
              <h3>Problema</h3>
              <p>Usuários estavam perdendo o histórico de simulações após fechar a aplicação ou navegar entre páginas, 
              causando frustração e perda de dados importantes.</p>
              
              <h3>Solução</h3>
              <p>Implementamos persistência adequada no banco de dados e modificamos o componente SimulationHistory 
              para recuperar adequadamente as simulações salvas.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Modificação no componente de histórico
useEffect(() => {
  const fetchSavedSimulations = async () => {
    try {
      const response = await axios.get('/api/simulations/history');
      if (response.data && Array.isArray(response.data)) {
        setSimulations(response.data);
      }
    } catch (error) {
      console.error("Erro ao buscar histórico de simulações:", error);
      toast.error("Não foi possível carregar o histórico de simulações");
    }
  };

  fetchSavedSimulations();
}, []);

// Implementação do endpoint no backend
router.get('/simulations/history', authenticateToken, async (req, res) => {
  try {
    const userId = req.user.id;
    const simulations = await Simulation.findAll({
      where: { userId },
      order: [['createdAt', 'DESC']],
      limit: 20
    });
    
    res.json(simulations);
  } catch (error) {
    console.error('Erro ao buscar histórico de simulações:', error);
    res.status(500).json({ message: 'Erro ao buscar histórico.' });
  }
});
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta correção garante que os usuários possam acessar seu histórico de simulações a qualquer momento, 
              mesmo após fechar o navegador ou fazer logout, melhorando significativamente a experiência do usuário 
              e a confiabilidade do sistema.</p>
            `,
            readmeLink: '#14032025---correção-do-problema-de-perda-de-histórico-de-simulações'
          },
          {
            id: 12,
            title: 'Melhoria na Exibição do Período de Operação das Simulações',
            content: `
              <h2>Melhoria na Exibição do Período de Operação das Simulações</h2>
              
              <h3>Descrição</h3>
              <p>Implementação de melhorias na forma como os períodos de operação são exibidos nas simulações.</p>
              
              <h3>Problema</h3>
              <p>Os períodos de operação das simulações eram apresentados de forma confusa, dificultando a compreensão pelos usuários.</p>
              
              <h3>Solução</h3>
              <p>Melhoramos a exibição com formatação de data mais clara, adição de tooltips explicativos e reorganização 
              das informações nas páginas de relatórios e configurações.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Formatação de data melhorada
const formatSimpleDate = (dateString) => {
  const date = new Date(dateString);
  return \`\${date.getDate().toString().padStart(2, '0')}/\${(date.getMonth() + 1).toString().padStart(2, '0')}/\${date.getFullYear().toString().slice(2)}\`;
};

// Utilizando a formatação nos relatórios
<div className="period-info">
  <span title="Data de início da simulação">
    <i className="fas fa-calendar-alt me-1"></i>
    {formatSimpleDate(simulation.start_date)}
  </span>
  <span className="mx-2">→</span>
  <span title="Data de término da simulação">
    <i className="fas fa-calendar-check me-1"></i>
    {formatSimpleDate(simulation.end_date)}
  </span>
</div>

// Adição de tooltips explicativos
<div className="d-flex align-items-center" title="Total de dias úteis no período">
  <i className="fas fa-business-time me-1 text-muted"></i>
  <span>{simulation.working_days} dias úteis</span>
</div>
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Estas melhorias facilitam a interpretação dos períodos de operação pelos usuários, 
              reduzindo confusão e melhorando a experiência geral ao analisar resultados de simulações.</p>
            `,
            readmeLink: '#14032025---melhoria-na-exibição-do-período-de-operação-das-simulações'
          },
          {
            id: 11,
            title: 'Implementação do Dashboard do Sequelize e Menu de Administração',
            content: `
              <h2>Implementação do Dashboard do Sequelize e Menu de Administração</h2>
              
              <h3>Descrição</h3>
              <p>Criação de um dashboard para visualizar e gerenciar modelos do Sequelize e implementação de um menu de administração.</p>
              
              <h3>Problema</h3>
              <p>Não havia uma interface para os administradores visualizarem e gerenciarem os modelos e tabelas do banco de dados de forma fácil.</p>
              
              <h3>Solução</h3>
              <p>Implementamos um dashboard completo do Sequelize para visualizar modelos, associações e dados, 
              além de um menu de administração para acesso a ferramentas administrativas.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Rota backend para listar modelos do Sequelize
app.get('/api/admin/sequelize/models', authenticateAdmin, async (req, res) => {
  try {
    // Lista todos os modelos disponíveis no Sequelize
    const db = require('../models');
    const models = Object.keys(db).filter(key => key !== 'sequelize' && key !== 'Sequelize')
      .map(modelName => {
        const model = db[modelName];
        return {
          name: modelName,
          tableName: model.tableName,
          attributes: Object.keys(model.rawAttributes).map(attr => ({
            name: attr,
            type: model.rawAttributes[attr].type.key,
            allowNull: model.rawAttributes[attr].allowNull || false,
            primaryKey: model.rawAttributes[attr].primaryKey || false
          })),
          associations: Object.keys(model.associations).map(assocName => ({
            name: assocName,
            type: model.associations[assocName].associationType,
            target: model.associations[assocName].target.name
          }))
        };
      });
    
    res.json(models);
  } catch (error) {
    console.error('Erro ao listar modelos do Sequelize:', error);
    res.status(500).json({ message: 'Erro no servidor.' });
  }
});

// Componente de frontend para o Dashboard do Sequelize
const SequelizeDashboard = () => {
  const [models, setModels] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [modelData, setModelData] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // ... código para carregar e exibir os modelos e dados ...
}
              </pre>
              
              <h3>Funcionalidades Implementadas</h3>
              <ul>
                <li>Visualização de todos os modelos Sequelize disponíveis</li>
                <li>Exibição dos atributos e tipos de cada modelo</li>
                <li>Visualização das associações entre modelos</li>
                <li>Navegação pelos dados de cada tabela</li>
                <li>Menu de administração com acesso fácil às ferramentas administrativas</li>
              </ul>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta implementação simplifica significativamente o trabalho de administração do banco de dados, 
              permitindo que administradores visualizem e gerenciem os modelos e dados sem necessidade de acessar 
              diretamente o banco de dados ou ferramentas externas.</p>
            `,
            readmeLink: '#14032025---implementação-do-dashboard-do-sequelize-e-menu-de-administração'
          },
          {
            id: 10,
            title: 'Correção do Erro de Coluna Ausente na Tabela Operations',
            content: `
              <h2>Correção do Erro de Coluna Ausente na Tabela Operations</h2>
              
              <h3>Descrição</h3>
              <p>Correção do erro causado pela ausência da coluna "period" na tabela de operações.</p>
              
              <h3>Problema</h3>
              <p>A aplicação apresentava erros ao tentar acessar a coluna "period" nas operações, que não existia no banco de dados.</p>
              
              <h3>Solução</h3>
              <p>Criamos e executamos uma migração para adicionar a coluna "period" à tabela operations, com valor padrão de 1.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Migração para adicionar a coluna 'period'
module.exports = {
  up: async (queryInterface, Sequelize) => {
    await queryInterface.addColumn('operations', 'period', {
      type: Sequelize.INTEGER,
      allowNull: false,
      defaultValue: 1
    });
  },
  
  down: async (queryInterface, Sequelize) => {
    await queryInterface.removeColumn('operations', 'period');
  }
};

// Como executar a migração:
// 1. Salve o arquivo como 'migrations/20250313000000-add-period-to-operations.js'
// 2. Execute o comando: npx sequelize-cli db:migrate
              </pre>
              
              <h3>Instruções para Execução da Migração</h3>
              <ol>
                <li>Acesse o container do backend: <code>docker exec -it investment-backend bash</code></li>
                <li>Navegue até o diretório do projeto: <code>cd /app</code></li>
                <li>Execute a migração: <code>npx sequelize-cli db:migrate</code></li>
                <li>Verifique se a migração foi aplicada corretamente: <code>npx sequelize-cli db:migrate:status</code></li>
              </ol>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta correção elimina os erros causados pela tentativa de acessar uma coluna inexistente, 
              permitindo que a aplicação funcione corretamente quando tenta agrupar operações por período.</p>
            `,
            readmeLink: '#13032025---correção-do-erro-de-coluna-ausente-na-tabela-operations'
          },
          {
            id: 9,
            title: 'Correção do problema de sobreposição do menu de administração',
            content: `
              <h2>Correção do problema de sobreposição do menu de administração</h2>
              
              <h3>Descrição</h3>
              <p>O menu dropdown de administração estava sendo sobreposto pelo conteúdo principal da aplicação, 
              tornando impossível acessar as opções do menu.</p>
              
              <h3>Problema</h3>
              <p>O menu dropdown de administração na barra lateral estava sendo sobreposto pelo conteúdo principal, 
              impedindo o acesso às opções como "Configuração de Email" e "Dashboard do Sequelize".</p>
              
              <h3>Solução</h3>
              <p>Movemos o menu de administração da barra lateral para o canto superior direito do cabeçalho, 
              junto com o perfil do usuário, e ajustamos o CSS para garantir o posicionamento correto.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
// Ajuste no HTML/JSX
<div className="navbar-nav flex-row order-md-last ms-auto">
  {isAdmin && (
    <div className="nav-item dropdown me-3">
      <a href="#" className="nav-link dropdown-toggle" onClick={handleDropdownToggle}>
        <span className="nav-link-icon">
          <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"&gt;
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" />
          </svg>
        </span>
        <span className="d-none d-md-inline">Administração</span>
      </a>
      <div className="dropdown-menu dropdown-menu-end">
        <Link to="/admin/email-config" className="dropdown-item">
          Configuração de Email
        </Link>
        <Link to="/admin/sequelize" className="dropdown-item">
          Dashboard do Sequelize
        </Link>
      </div>
    </div>
  )}
</div>

// Ajustes no CSS
/* Dropdown no cabeçalho */
.navbar-nav .dropdown-menu {
  position: absolute;
  right: 0;
  left: auto;
  top: 100%;
  margin-top: 0.5rem;
  z-index: 1500;
}

.dropdown-menu-end {
  right: 0;
  left: auto;
}

/* Ajustar o alinhamento do navbar para direita */
.ms-auto {
  margin-left: auto !important;
}
              </pre>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta correção permite que administradores acessem facilmente as ferramentas administrativas 
              do sistema, melhorando a usabilidade e a experiência do usuário.</p>
            `,
            readmeLink: '#15032025---correção-do-problema-de-sobreposição-do-menu-de-administração'
          },
          {
            id: 8,
            title: 'Erro "prevLogs[type] is not iterable"',
            content: `
              <h2>Erro "prevLogs[type] is not iterable"</h2>
              
              <h3>Descrição</h3>
              <p>Erro ao acessar a página de resultados da simulação gerada e clicar no botão "Ver Detalhes".</p>
              
              <h3>Problema</h3>
              <p>O erro ocorria na função <code>addToLog</code> do componente <code>Reports.js</code>, onde o código 
              tentava usar o operador spread (<code>...</code>) em <code>prevLogs[type]</code>, mas essa propriedade 
              não era um array em algumas situações.</p>
              
              <h3>Solução</h3>
              <p>Modificamos a função <code>addToLog</code> para garantir que <code>prevLogs[type]</code> seja sempre tratado como um array.</p>
              
              <h3>Exemplo de Código</h3>
              <pre>
const addToLog = (type, message) => {
  const logEntry = {
    timestamp: new Date(),
    message,
    details: typeof message === 'object' ? JSON.stringify(message) : message
  };
  
  setLogs(prevLogs => {
    // Garantir que prevLogs seja um objeto válido
    const safeObj = prevLogs || {};
    
    // Garantir que prevLogs[type] seja um array
    const existingLogs = Array.isArray(safeObj[type]) ? safeObj[type] : [];
    
    return {
      ...safeObj,
      [type]: [logEntry, ...existingLogs].slice(0, 100)
    };
  });
};
              </pre>
              
              <h3>Análise do Erro</h3>
              <p>O erro ocorria porque:</p>
              <ol>
                <li>Quando o componente era montado pela primeira vez, <code>prevLogs</code> poderia ser undefined</li>
                <li>Mesmo quando <code>prevLogs</code> existia, <code>prevLogs[type]</code> poderia não ser um array</li>
                <li>O operador spread (<code>...</code>) só funciona com objetos iteráveis (como arrays)</li>
              </ol>
              
              <h3>Impacto no Sistema</h3>
              <p>Esta correção elimina um erro que impedia os usuários de visualizar detalhes das simulações, 
              melhorando a estabilidade e usabilidade do sistema de relatórios.</p>
            `,
            readmeLink: '#14032025---correção-do-erro-prevlogstype-is-not-iterable'
          },
          // ... outros itens existentes
        ];
        
        // Procurar o conteúdo correspondente ao hash
        const findContent = knowledgeBaseData.find(item => 
          item.readmeLink.substring(1) === hash || 
          item.readmeLink.substring(1).toLowerCase() === hash.toLowerCase()
        );
        
        if (findContent) {
          setContent(findContent);
          setNotFound(false);
        } else {
          setNotFound(true);
        }
      } catch (error) {
        console.error('Erro ao carregar conteúdo:', error);
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [location.hash]);
  
  return (
    <MainLayout>
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col">
                <div className="page-title">
                  <i className="fas fa-book-open me-2"></i>
                  {content ? content.title : 'Documentação'}
                </div>
              </div>
              <div className="col-auto ms-auto d-print-none">
                <div className="btn-list">
                  <Link to="/admin/knowledge-dashboard" className="btn">
                    <i className="fas fa-arrow-left me-2"></i>
                    Voltar para Base de Conhecimento
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="page-body">
          <div className="container-xl">
            {loading ? (
              <div className="card">
                <div className="card-body text-center p-4">
                  <div className="spinner-border text-primary" role="status"></div>
                  <div className="mt-3">Carregando documentação...</div>
                </div>
              </div>
            ) : notFound ? (
              <div className="card">
                <div className="card-body text-center p-4">
                  <div className="empty">
                    <div className="empty-icon">
                      <i className="fas fa-search fa-3x text-muted"></i>
                    </div>
                    <p className="empty-title">Documentação não encontrada</p>
                    <p className="empty-subtitle text-muted">
                      Não foi possível encontrar a documentação solicitada.
                    </p>
                    <div className="empty-action">
                      <Link to="/admin/knowledge-dashboard" className="btn btn-primary">
                        <i className="fas fa-arrow-left me-2"></i>
                        Voltar para Base de Conhecimento
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <div dangerouslySetInnerHTML={{ __html: content.content }}></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ReadmeChat; 